import {fallbackRoutes} from './configRoutes';
import { Auth } from 'aws-amplify';
import * as ENV from '@/env-vars';

import {signInHandler} from '@/config'
import { clearCache } from '@/library/utils/cacheSystem';

export default async (to, from, next) => {

	try{

		let isSignedIn = false;

		try{

			let authUser = await Auth.currentAuthenticatedUser()
			isSignedIn = true
		}catch(e){}

		const tieneQuery = Object.keys(to.query).length > 0 && to.meta.requiresAuth !== false;

		if( !isSignedIn && tieneQuery && to.meta.externo!==true ){

			try{

				let resp = await signInHandler(to.query, next)
				isSignedIn = resp===true
			}catch(e){}
		}else if( !isSignedIn )	throw new Error('No ha iniciado sesion.');

		if( tieneQuery && to.meta.externo!==true ){
			next({ name: to.name, query:{} })
		}else if( tieneQuery && to.meta.externo===true ){
			next()
		}else if(  autoAccess( to.meta ) ){
			
			next({ name: fallbackRoutes['principal'] });
		}else{
			
			next();
		}

	}catch(err){

		console.log('NO AUTH', to.query)
		console.log('NO AUTH', to.meta)
		
		// en caso de que el destino SI REQUIERA de autentificacion, pero no está
		// autentificado, este será redireccionado al login "HARD REFRESH"
		if( to.meta.requiresAuth === false || to.meta.externo===true ){
			next();
		}else{
			clearCache()
			next({name: 'inicio-sesion'})
		}
	}
};

function tienePermiso( metaData, permisos ){

	let tiene = false;
	for( let permiso of permisos ){


		if( metaData.permiso === permiso || !metaData.permiso )
			return true;
	}
	return metaData.permiso === true;
}

// verifica si la ruta requiere o no ser redireccionada
// en caso de estar logeado
let autoAccess = ( routeMeta ) => routeMeta.requiresAuth === false;
